import { defineComponent, ref } from "vue";
import IconButton from "./base/IconButton.vue.mjs";
import MessageBox from "./base/MessageBox/index.mjs";
import AudioSettingTab from "./AudioSettingTab.vue.mjs";
import AudioIcon from "./AudioIcon.vue.mjs";
import { useI18n } from "../../locales/index.mjs";
import "../../directives/vClickOutside.mjs";
import { isGetUserMediaSupported, isEnumerateDevicesSupported } from "../../utils/mediaAbility.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "AudioMediaControl",
  props: {
    hasMore: { type: Boolean, default: true },
    isMuted: { type: Boolean },
    isDisabled: { type: Boolean, default: false },
    audioVolume: { default: 0 }
  },
  emits: ["click"],
  setup(__props, { emit: emits }) {
    const showAudioSettingTab = ref(false);
    const isSupportAudioMedia = isGetUserMediaSupported && isEnumerateDevicesSupported;
    const { t } = useI18n();
    async function handleClickIcon() {
      if (!isSupportAudioMedia) {
        MessageBox({
          title: t("Note"),
          message: t("The current browser does not support capturing audio"),
          confirmButtonText: t("Sure")
        });
        return;
      }
      emits("click");
      showAudioSettingTab.value = false;
    }
    function handleMore() {
      showAudioSettingTab.value = !showAudioSettingTab.value;
    }
    function handleHideAudioSettingTab() {
      if (showAudioSettingTab.value) {
        showAudioSettingTab.value = false;
      }
    }
    return { __sfc: true, emits, showAudioSettingTab, isSupportAudioMedia, t, handleClickIcon, handleMore, handleHideAudioSettingTab, IconButton, AudioSettingTab, AudioIcon };
  }
});
export {
  _sfc_main as default
};
